import { RouteObject } from 'react-router';

const ticketAnsichtRoutes: RouteObject[] = [
  {
    path: 'ticket',
    children: [
      {
        path: 'ansicht/:ticketnummerOderKennzeichen',
        lazy: () => import('./page/ticket-ansicht-page.tsx'),
      },
    ],
  },
];

export default ticketAnsichtRoutes;
